// Animation library built for numbered notes
// Creator: Adam Snyder
// Last modified: 7/7/2020


export default class Animation {

constructor(elementName, startPosition, endPosition, speed, randomToggle, ) {
    this.speed = speed || .1;
    this.startPos = startPosition;
    this.endPos = endPosition;
    this.elementName = elementName;
    this.randomToggle = randomToggle || false;
}

// Moves an image from the left to the right given a start position and
// an end position. ElementName is a string with the id tag
// for the div the image is located in.
  animateLeftToRight = () => {
    const elem = document.getElementById(this.elementName);
    var pos = this.startPos;
    var endPos = this.endPos;
    var startPos = this.startPos;
    var interval = setInterval(frame,16.6);
    elem.style.transform = "scaleX(1)";

    function frame() {
      if (pos >= endPos) {
        pos = startPos;
      } 
      else {
        pos += 0.5; 
        elem.style.left = pos + "%";
      }
    }
    return interval;
  };

// Moves an  image back and forth with a given start position and end position in
// percentage of the screen for scalability. ElementName is a string with the id tag
// for the div the image is located in.
  animateBacknForth = (startPos, endPos, speed, randomToggle) => {
    const elem = document.getElementById(this.elementName);
    var flip = false;
    var random = 0;
    var interval = setInterval(frame,16.6);
    var pos = startPos;
    var speed = speed;
    var startP = startPos;
    var endP = endPos;
    var randomToggle = randomToggle;

    function frame() {

      if(pos >= 70) {
        pos = 70;
        endP = 50;
      }

      if(flip == true) {
        pos -= speed;
        elem.style.left = pos + "%"; 
        if(pos <= (startP - random)) {
          flip = false;
          elem.style.transform = "scaleX(1)";
          if(randomToggle) {
            random = Math.floor(Math.random() * 20);
          }
        }
      }
      else {
        pos += speed; 
        elem.style.left = pos + "%"; 
        if(pos >= (endP + random)) {
          flip = true;
          elem.style.transform = "scaleX(-1)";
          if(randomToggle) {
            random = Math.floor(Math.random() * 20);
          }
        }
      }
    }
    return interval;
  }

  animateUpAndDown = (elementName, startPos, endPos, speed, randomToggle) => {
    var flip = false;
    var random = 0;
    const elem = document.getElementById(elementName);
    var interval = setInterval(frame, 16.6);
    var pos = startPos;
    var speed = speed;
    var startP = startPos;
    var endP = endPos;
    var randomToggle = randomToggle;

    function frame() {
      if(flip == false) {
        pos += speed;
        elem.style.bottom = pos + "%";
        if(pos > (endP + random)) {
          flip = true;
          if(randomToggle) {
            random = Math.floor(Math.random() * 20);
          }
        }
      }
      else {
        pos -= speed;
        elem.style.bottom = pos + "%"; 
        if(pos < (startP - random)) {
          flip = false;
          if(randomToggle) {
            random = Math.floor(Math.random() * 20);
          }
        }
      }
    }
    return interval;
  }


  animateTopToBottom = (elementName, startPos, endPos) => {
    var pos = startPos;
    const elem = document.getElementById(elementName);
    var interval = setInterval(frame, 16.6);
    function frame() {
      if (startPos >= endPos) {
        startPos = 0;
      } 
      else {
        startPos += 0.5; 
        elem.style.top = startPos + "%"; 
      }
    }
    return interval;
  } 

  yoYoMotion = (elementName, startPos, endPos) => {
    var pos = startPos;
    const elem = document.getElementById(elementName);
    var count = 0;
    setInterval(frame, 16.6);
    function  frame () {
      if(pos >= endPos) {
        pos = 0;
        count = 0;
      }
      else {
        pos = Math.pow(2, 10 * (count - 1)) * Math.cos(20 * Math.PI * x / 3 * count);
        count++;
      }
    }
  }

  circleMotion = (elementName, radius, startPoint) => {
    var interval = setInterval(frame, 16.6);
    const elem = document.getElementById(elementName);
    function  frame () {
      
    }
    return interval;
  }

  sineMotion = () => {
    var interval = setInterval(frame, 16.6);
    const elem = document.getElementById(elementName);
    function  frame () {
      
    }
    return interval;
  }
}